import type { I18n } from '@lingui/core'
import { Trans } from '@lingui/react'
import classNames from 'classnames'
import { type ReactChild, type VFC } from 'react'

import IconCaretDown from 'views/components/atoms/Icon/IconCaretDown'
import TextWithIcon from 'views/components/molecules/TextWithIcon'

import type { ProductAttributes } from '..'

export const CLIENTSIDE_HOOK_CHILDREN_WRAPPER =
  'productVariantsAttribute-Wrapper'

interface AttributePickerRegionCollapsibleWrapperProps {
  children: ReactChild
  i18n: I18n
  variantAttribute: ProductAttributes
  isSingleAttributeProduct: boolean
  packageSizeAttribute: boolean
}

const AttributePickerRegionCollapsibleWrapper: VFC<
  AttributePickerRegionCollapsibleWrapperProps
> = ({
  children,
  i18n,
  variantAttribute,
  isSingleAttributeProduct,
  packageSizeAttribute,
}) => {
  const itemsThreshold = 6
  const isCollapsible: boolean = variantAttribute.values.length > itemsThreshold
  const hasTileTeaser =
    isSingleAttributeProduct && !packageSizeAttribute && isCollapsible
  const hasPillTeaser = !isSingleAttributeProduct && isCollapsible

  const childClasses = classNames({
    'o-ProductVariantsAttributePicker-tile-teaser': hasTileTeaser,
    'o-ProductVariantsAttributePicker-pill-teaser': hasPillTeaser,
  })

  const collapsibleLabel = (
    <div
      role="button"
      className="o-ProductVariantsAttributePicker-Collapsible u-padding--top"
      data-clientside-hook="attributePicker-collapsible--label"
      data-trans-open={i18n?._('general.label.showNMore', {
        count: variantAttribute.values.length,
      })}
      data-trans-close={i18n?._('general.label.showLess')}
      data-current-state="closed"
    >
      <TextWithIcon icon={<IconCaretDown size="small" />} right centered>
        <Trans
          id="general.label.showNMore"
          values={{
            count: variantAttribute.values.length - itemsThreshold,
          }}
        />
      </TextWithIcon>
    </div>
  )

  return (
    <>
      <div
        data-clientside-hook={CLIENTSIDE_HOOK_CHILDREN_WRAPPER}
        className={childClasses}
      >
        {children}
      </div>
      {(hasTileTeaser || hasPillTeaser) && (
        <div className="o-ProductVariantsAttributePicker-Collapsible-mobile-hidden">
          {collapsibleLabel}
        </div>
      )}
    </>
  )
}
export default AttributePickerRegionCollapsibleWrapper
